<div class="avatar-container">
    @if (user?.profile_image | userImage | async; as image) {
        <div
            class="image-container box-shadow-avatar"
            [ngStyle]="{ backgroundImage: 'url(' + image + ')' }"></div>
    } @else {
        <div class="image-container avatar-placeholder"></div>
    }
</div>